import {getCookie, insertThrobber, removeThrobber, setCookie} from '../Utility/GlobalFunctions';
import {RequestService} from '../RequestService/RequestService';
import {Modal} from '../Modal/Modal';

export class DownloadFormControler {
  private downloadOpenModal;
  private cookieName;
  private downloadForm;

  constructor() {
    if (document.getElementsByClassName('js-slnr-downloads') || document.getElementsByClassName('js-productDownload')) {
      this.downloadOpenModal = document.querySelectorAll('.js-download-mediaCart');
      this.downloadForm = document.querySelector('.js-downloadForm');
      this.cookieName = 'schl_site_opt_in_trigger';
      if (this.downloadForm) {
        this.listeners();
      }
    }
  }

  listeners() {
    const handler = function (e) {
      e.preventDefault();
      const href = e.currentTarget.getAttribute('href');
      const filePath = <HTMLInputElement> document.querySelector('.js-filePath');
      if (filePath) {
        filePath.value = href;
      }
      const filename = e.currentTarget.getAttribute('data-filename');
      const downloadOpenmodal = document.querySelectorAll('.js-download-mediaCart');
      downloadOpenmodal.forEach(elem => {
        elem.removeEventListener('click', handler, true);
      });
      let modalID = e.currentTarget.dataset.modal;
      let modal = document.getElementById(modalID);
      if (modal) {
        modal.classList.add('modal-visible');
        const closeModalButton = modal.querySelector('.js-close-downloadmodal') as HTMLLinkElement;
        const closeModalX      = modal.querySelector('.js-close-modal') as HTMLLinkElement;
        [closeModalButton, closeModalX].forEach(closeModal => {
          closeModal.addEventListener('click', event => {
            if (event.currentTarget) {
              if (event.currentTarget instanceof HTMLElement) {
                setCookie('schl_site_opt_in_trigger', 'false');
                let modalVisible = document.querySelector('.modal-visible');
                if (modalVisible) {
                  modalVisible.classList.remove('modal-visible');
                }
                const a = document.createElement('a');
                a.style.display = 'none';
                document.body.appendChild(a);
                // Set the HREF to a Blob representation of the data to be downloaded
                a.href = href;
                // Use download attribute to set set desired file name
                a.setAttribute('download', filename);
                // Trigger the download by simulating click
                a.click();
                // Cleanup
                window.URL.revokeObjectURL(a.href);
                document.body.removeChild(a);
                document.body.classList.remove('modal-body', 'modal-fadeOut');
              }
            }
          });
        });
        document.body.classList.add('modal-body');
      }
    };
    let cookieOpt = getCookie(this.cookieName);
    if (!cookieOpt) {
      this.downloadOpenModal.forEach(elem => {
        elem.addEventListener('click', handler, true);
      });
    }

    this.downloadForm.addEventListener('submit', e => {
      e.preventDefault();
      insertThrobber(this.downloadForm);
      this.submitForm();
    });
  }
  private async submitForm() {
    let formData = new FormData(this.downloadForm);
    const modalContent = this.downloadForm.parentElement;
    let cookieOpt = getCookie(this.cookieName);
    if (!cookieOpt) {
      const options = {
        method: this.downloadForm.method,
        body: formData,
      };
      const data = await new RequestService().getRequestJson(this.downloadForm.action, options);
      if (data.captchaNotValid) {
        removeThrobber();
        const captchaErrorElement = this.downloadForm.querySelector('.js-error-captcha');
        if (captchaErrorElement) {
          captchaErrorElement.insertAdjacentHTML('beforeend', data.captchaNotValid);
          captchaErrorElement.classList.remove('hidden');
        }
      } else if (data.isHtml) {
        setCookie('schl_site_opt_in_trigger', 'true');
        modalContent.innerHTML = '';
        modalContent.insertAdjacentHTML('beforeend', data.isHtml);
        new Modal();
      }

    }
  }
}
